const APP_DIALOG_TOGGLE = 'APP_DIALOG_TOGGLE';
const APP_DIALOG_OPEN = 'APP_DIALOG_OPEN';
const APP_DIALOG_CLOSE = 'APP_DIALOG_CLOSE';

const toggleDialog = component => ({ type: APP_DIALOG_TOGGLE, component });
const openDialog = component => ({ type: APP_DIALOG_OPEN, component });
const closeDialog = () => ({ type: APP_DIALOG_CLOSE });

export default {
	APP_DIALOG_TOGGLE,
	APP_DIALOG_OPEN,
	APP_DIALOG_CLOSE,
	toggleDialog,
	openDialog,
	closeDialog,
};
